import { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import styles from '../GranularityDropdown/GranularityDropdown.module.scss';

interface Props {
  value: 'bar' | 'line';
  onChange: (value: 'bar' | 'line') => void;
}

const OPTIONS = [
  { label: 'Bar Chart', value: 'bar' as const },
  { label: 'Line Chart', value: 'line' as const },
];

const ChartTypeDropdown = ({ value, onChange }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedOption = OPTIONS.find((o) => o.value === value) || OPTIONS[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className={styles.selecter}>
      <button
        type='button'
        className={styles.customToggle}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon className={styles.infoGraphicIcon} icon='material-symbols:bar-chart' />
        <span className={styles.selectedLabel}>{selectedOption.label}</span>
        <Icon className={styles.arrowDownIcon} icon='bxs:down-arrow' />
      </button>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          <ul className={styles.optionsList}>
            {OPTIONS.map((option) => (
              <li key={option.value} className={styles.option}>
                <button
                  type='button'
                  className={styles.optionButton}
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                >
                  {option.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ChartTypeDropdown;
